/** 빌링 연동 판매 채널 */
export const BillingSaleChannel = {
    /** 고객 채널 */
    NV: 'NV',
    /** 판매자 충전금 */
    MP: 'MP',
} as const

export type BillingSaleChannelType = Constant<typeof BillingSaleChannel>

/** 주문서 서비스 타입 */
export const Service = {
    /** 가맹점, 예약, 블로그, 로컬페이 등 */
    C1: 'C1',
    /** 스마트스토어 */
    C2: 'C2',
    /** 중고나라(에스크로) */
    C3: 'C3',
} as const

export type ServiceType = Constant<typeof Service>

/** 빌링 SDK용 할부 구분 값 */
export const FreeInstallmentType = {
    /** 무이자 */
    ALL: '01',
    /** 부분 무이자 */
    PART: '02',
} as const
